angular.module('bbl.module.users', [
  'bbl.services',
  'bbl.module.users.routing',
  'bbl.module.users.controller',
]);

require('./users.style.less');
require('./users.controller');
require('./users.routing');


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/users/users.module.js
 ** module id = 375
 ** module chunks = 0
 **/